import './assets/fonts/fonts.css'
import './index.css'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import { MuiThemeProvider } from '@material-ui/core/styles'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import mobileTheme from './mobileTheme'
import reportWebVitals from './reportWebVitals'
import configureStore from './store/store'

export const store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={mobileTheme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
